// data
import {
    reduxTextStateSite,
} from 'data'

// main
export function checkRequiredFieldsSite({
    fields,
    formInfoObject,
    reduxText,
    subContentTypeRequiredFields,
}: {
    fields?: any
    formInfoObject: any
    reduxText: reduxTextStateSite['data']
    subContentTypeRequiredFields?: any
}) {
    const errorArray: any[] = []
    const errorObject: any = {}

    const newFields = fields || formInfoObject.data?.fields

    // Transform subContentTypeRequiredFields object to string array
    let fieldsRequired: string[] = []
    const conditionalRequiredFields: { fieldName: string; condition: string }[] = []

    if (subContentTypeRequiredFields) {
        Object.keys(subContentTypeRequiredFields).forEach(fieldName => {
            const fieldConfig = subContentTypeRequiredFields[fieldName]

            // Handle always required fields
            if (fieldConfig?.isRequired === true) {
                fieldsRequired.push(fieldName)
            }

            // Handle conditionally required fields
            if (fieldConfig?.isRequiredIf) {
                conditionalRequiredFields.push({
                    fieldName,
                    condition: fieldConfig.isRequiredIf
                })
            }
        })
    } else {
        fieldsRequired = formInfoObject.fieldsRequired || []
    }

    if (['project'].includes(formInfoObject.model)) {
        const linkUrl = formInfoObject.fields.link_url
        let linkUrlError = ''
        if (linkUrl) {
            if (linkUrl.includes('spotify.com/album')) {
                linkUrlError = reduxText[5496]
            } else if (linkUrl.includes('spotify.com/intl-fr/album')) {
                linkUrlError = reduxText[5496]
            } else if (linkUrl.includes('vimeo.com/manage')) {
                linkUrlError = reduxText[5561]
            }
        }
        if (linkUrlError) {
            errorArray.push('link_url')
            errorObject.link_url = linkUrlError
        }
    }

    // Dynamic field validation - handles objects, arrays, and primitive values
    if (fieldsRequired) {
        fieldsRequired.map((field: string) => {
            const fieldValue = newFields[field]
            let isValid = false

            // Check if field exists and has a valid value
            if (fieldValue !== undefined && fieldValue !== null) {
                // Handle arrays
                if (Array.isArray(fieldValue)) {
                    isValid = fieldValue.length > 0
                }
                // Handle objects (but not arrays)
                else if (typeof fieldValue === 'object') {
                    isValid = Object.keys(fieldValue).length > 0
                }
                // Handle primitive values (string, number, boolean)
                else {
                    isValid = fieldValue !== '' && fieldValue !== 0
                }
            }

            if (!isValid) {
                errorArray.push(field)
                errorObject[field] = reduxText[2856]
            }
            return false
        })
    }

    // Handle conditionally required fields based on isRequiredIf
    if (conditionalRequiredFields.length > 0) {
        conditionalRequiredFields.forEach(({ fieldName, condition }) => {
            const fieldValue = newFields[fieldName]
            let shouldBeRequired = false

            // Parse the condition (format: "fieldName=value" or "fieldName=not__value")
            const conditionParts = condition.split('=')
            if (conditionParts.length === 2) {
                const [conditionFieldName, conditionValue] = conditionParts
                let conditionFieldValue = newFields[conditionFieldName]

                // If condition field is not found, try to find similar field names
                if (conditionFieldValue === undefined) {
                    const availableFields = Object.keys(newFields)
                    const similarFields = availableFields.filter(field =>
                        field.includes(conditionFieldName) || conditionFieldName.includes(field)
                    )

                    // Try the first similar field if found
                    if (similarFields.length > 0) {
                        conditionFieldValue = newFields[similarFields[0]]
                    }
                }

                // Check if the condition field has a value
                if (conditionFieldValue !== undefined && conditionFieldValue !== null) {
                    // Extract the actual value for comparison
                    let actualValue = conditionFieldValue

                    // Check if it's an array first
                    if (Array.isArray(conditionFieldValue)) {
                        // Handle array case - check if any item in the array matches the condition value
                        const matchingItems = conditionFieldValue.filter(item => {
                            let itemValue = item
                            if (typeof item === 'object' && item !== null) {
                                itemValue = item.id || item.value || item
                            }
                            return String(itemValue) === String(conditionValue)
                        })

                        if (matchingItems.length > 0) {
                            actualValue = conditionValue // Use the condition value since we found a match
                        } else {
                            // Fallback to first item for other logic
                            const firstItem = conditionFieldValue[0]
                            if (typeof firstItem === 'object' && firstItem !== null) {
                                actualValue = firstItem.id || firstItem.value || firstItem
                            } else {
                                actualValue = firstItem
                            }
                        }
                    } else if (typeof conditionFieldValue === 'object' && conditionFieldValue !== null) {
                        // Handle single object case
                        if (conditionFieldValue.id !== undefined) {
                            actualValue = conditionFieldValue.id
                        } else if (conditionFieldValue.value !== undefined) {
                            actualValue = conditionFieldValue.value
                        }
                    }

                    // Handle special case for 'true' value
                    if (conditionValue === 'true' && actualValue) {
                        shouldBeRequired = true
                    } else {
                        // Handle negation case (not__value)
                        const valueParts = conditionValue.split('__')
                        if (valueParts.length === 2 && valueParts[0] === 'not') {
                            if (String(actualValue) !== String(valueParts[1])) {
                                shouldBeRequired = true
                            }
                        } else {
                            // Handle normal equality case
                            if (String(actualValue) === String(conditionValue)) {
                                shouldBeRequired = true
                            }
                        }
                    }
                }
            }

            // If the field should be required, validate it
            if (shouldBeRequired) {
                let isValid = false

                // Check if field exists and has a valid value
                if (fieldValue !== undefined && fieldValue !== null) {
                    // Handle arrays
                    if (Array.isArray(fieldValue)) {
                        isValid = fieldValue.length > 0
                    }
                    // Handle objects (but not arrays)
                    else if (typeof fieldValue === 'object') {
                        isValid = Object.keys(fieldValue).length > 0
                    }
                    // Handle primitive values (string, number, boolean)
                    else {
                        isValid = fieldValue !== '' && fieldValue !== 0
                    }
                }

                if (!isValid) {
                    errorArray.push(fieldName)
                    errorObject[fieldName] = reduxText[2856]
                }
            }
        })
    }

    if (process.env.NODE_ENV === 'development') console.log('errorArray', errorArray)

    // Output
    if (errorArray.length === 0) {
        return 'ok'
    } else {
        return errorObject
    }
}
